angular.module('rings-app.grandfather', ['ui.router', 'templates-app', 'constants'])
.config(function ($stateProvider, myConfig) {
  $stateProvider
    .state('app', {
      abstract: true,
      template: '<ui-view></ui-view>',
      resolve: {
        'login': function (loginService, $q, $http) {
          var roleDefined = $q.defer();
          //var _baseurl = config.apiUrl + 'login?project=rings';

          /**
           * In case there is a pendingStateChange means the user requested a $state,
           * but we don't know yet user's userRole.
           *
           * Calling resolvePendingState makes the loginService retrieve his userRole remotely.
           */
          if (loginService.pendingStateChange) {
            var userToken = localStorage.getItem('userToken');

            var loginPromise = $http({
                 method  :'GET',
                 url: myConfig.apiUrl + 'login?project=rings', //'http://127.0.0.1:8000/v1/login?project=rings',
                 withCredentials: true,
                 headers :{'authorization':'Basic ' + userToken}
                    });

            return loginService.resolvePendingState(loginPromise);
          } else {
            roleDefined.resolve();
          }
          return roleDefined.promise;
        }
      }
    });
});
